export default "__VITE_ASSET__DTOKTkwH__"